import React, { ReactNode } from 'react';
import 'src/shared/components/error-text/error-text.style.scss';

const ErrorText = ({children}: {children: ReactNode}): JSX.Element => {
    return (
        <div className='error'>{children}</div>
    )
}

export default ErrorText;